import type { ToolDefinition } from './types';

/**
 * @class Tool
 * @description Centralized tool definitions and instances.
 */
export class Tool implements ToolDefinition {
  public readonly name: string;
  public readonly id: string;
  public readonly toggle: boolean;

  constructor(name: string, id: string, toggle: boolean) {
    this.name = name;
    this.id = id;
    this.toggle = toggle;
  }

  toString(): string {
    return this.name;
  }

  /**
   * Retrieves all available drawing and selection tools.
   */
  static getAllTools(): Tool[] {
    return [
      Tool.Line, Tool.Circle, Tool.Rectangle, Tool.Pen, Tool.Brush,
      Tool.Spray, Tool.Flood_Fill, Tool.Eraser, Tool.Eye_Dropper,
      Tool.Text, Tool.Wand, Tool.Rounded_Rectangle, Tool.Ellipse,
      Tool.RectSelect, Tool.EllipseSelect, Tool.Lasso, Tool.Crop,
      Tool.Pan, Tool.MoveSelection, Tool.MoveContent,
      Tool.VectorSelect, Tool.PolySelect,
      Tool.SingleRowSelect, Tool.SingleColumnSelect, Tool.CircleSelect
    ];
  }

  // Static instances
  static readonly Line: Tool = new Tool('Line', 'btn-line', true);
  static readonly Circle: Tool = new Tool('Circle', 'btn-circle', true);
  static readonly Rectangle: Tool = new Tool('Rectangle', 'btn-rect', true);
  static readonly Pen: Tool = new Tool('Pen', 'btn-pen', true);
  static readonly Brush: Tool = new Tool('Brush', 'btn-brush', true);
  static readonly Spray: Tool = new Tool('Spray', 'btn-spray', true);
  static readonly Flood_Fill: Tool = new Tool('Flood Fill', 'btn-flood-fill', true);
  static readonly Eraser: Tool = new Tool('Eraser', 'btn-eraser', true);
  static readonly Eye_Dropper: Tool = new Tool('Eye Dropper', 'btn-eye-dropper', true);
  static readonly Text: Tool = new Tool('Text', 'btn-text', true);
  static readonly Wand: Tool = new Tool('Wand', 'btn-wand', true);
  static readonly Rounded_Rectangle: Tool = new Tool('Rounded Rectangle', 'btn-rounded-rect', true);
  static readonly Ellipse: Tool = new Tool('Ellipse', 'btn-ellipse', true);
  static readonly Zoom_In: Tool = new Tool('Zoom In', 'btn-zoom-in', false);
  static readonly Zoom_Out: Tool = new Tool('Zoom Out', 'btn-zoom-out', false);
  static readonly Undo: Tool = new Tool('Undo', 'btn-undo', false);
  static readonly Redo: Tool = new Tool('Redo', 'btn-redo', false);
  static readonly RectSelect: Tool = new Tool('Rect Select', 'btn-rect-select', true);
  static readonly EllipseSelect: Tool = new Tool('Ellipse Select', 'btn-ellipse-select', true);
  static readonly Lasso: Tool = new Tool('Lasso', 'btn-lasso', true);
  static readonly PolySelect: Tool = new Tool('Polygon Select', 'btn-poly-select', true);
  static readonly Crop: Tool = new Tool('Crop', 'btn-crop', true);
  static readonly Pan: Tool = new Tool('Pan', 'btn-pan', true);
  static readonly MoveSelection: Tool = new Tool('Move Selection', 'btn-move-selection', true);
  static readonly MoveContent: Tool = new Tool('Move Content', 'btn-move-content', true);
  static readonly VectorSelect: Tool = new Tool('Vector Select', 'btn-vector-select', true);
  
  // Newly added selection tools for full coverage
  static readonly SingleRowSelect: Tool = new Tool('Single Row Select', 'btn-single-row-select', true);
  static readonly SingleColumnSelect: Tool = new Tool('Single Column Select', 'btn-single-column-select', true);
  static readonly CircleSelect: Tool = new Tool('Circle Select', 'btn-circle-select', true);
}
